import { createContext, useContext, useEffect, useState } from "react";
import { Auth } from "@definitions/auth";

type AuthContextType = {
  auth: Auth,
  setAuth: (auth:Auth) => void,
}

const AuthContext = createContext({
  auth: { },
  setAuth: (auth:Auth) => {}
});

export const useAuth = ():AuthContextType => {
  const { auth, setAuth } = useContext(AuthContext);

  return { auth, setAuth };
}

const AuthProvider = ({ children }: any) => {
  const [ auth, setAuth ] = useState<Auth>({});
  const [ mounting, setMounting ] = useState(true);

  useEffect(() => {
    const storedAuth = localStorage.getItem('auth');

    if (storedAuth) {
      setAuth(JSON.parse(storedAuth));
    }

    setMounting(false);
  }, [])

  useEffect(() => {
    // Don't let the initial mount trigger a save as it clobbers saved data.
    if (mounting) { return; }
    localStorage.setItem('auth', JSON.stringify(auth));
  }, [auth])

  return (
    <AuthContext.Provider value={{ auth, setAuth }}>
      {children}
    </AuthContext.Provider>
  );
}

export default AuthProvider;